/**
 * Handles the product slider functionality for the Ombraz V2 Collection PDP
 */
function v2CollectionPdpSlider() {
  // Select all necessary elements within the card
  const cards = Array.from(
    document.querySelectorAll(".ombraz-product-v2__card")
  );

  if (!cards.length) return;

  cards.forEach((card) => {
    const featuredImageElement = card.querySelector("[data-feaure-image]");
    const sideShieldToggle = card.querySelector("label input[type=checkbox]");
    const productImageUrl = card.querySelector(
      ".ombraz-product-v2__card-feature-image-link"
    );
    const productReviewUrl = card.querySelector(".klaviyo-star-rating-wrapper");
    const productCardUrl = card.querySelector(".ombraz-product-v2__card-url");
    const productVariantTitle = card.querySelector(
      ".ombraz-product-v2__card-variant-title > p"
    );
    const productPrice = card.querySelector(
      ".ombraz-product-v2__current-price"
    );
    const sizeButtons = {
      regular: card.querySelector("label[for^=regular] input[type=radio]"),
      narrow: card.querySelector("label[for^=narrow] input[type=radio]"),
      xl: card.querySelector("label[for^=xl] input[type=radio]"),
    };
    const slides = Array.from(
      card.querySelectorAll(".ombraz-product-v2-slide")
    );

    // Only process cards that have the required elements (main product cards, not accessories)
    if (!featuredImageElement || !slides.length) return;

    const quickAddButton = card
      .closest(".ombraz-product-v2__grid-item")
      .querySelector(".ombraz-product-v2__add-to-cart button");

    // Initialize variables
    let activeSlide = slides[0];
    let isSideShieldAdded = false;
    let currentSize = "regular"; // Default size
    let alertShownForCurrentSlide = false;

    /**
     * Preloads an image to improve performance
     * @param {string} url - The URL of the image to preload
     */
    function preloadImage(url) {
      const img = new Image();
      img.src = url;
    }

    /**
     * Updates the product information based on the selected slide and size
     * @param {HTMLElement} slide - The selected slide element
     * @param {string} size - The selected size (default: currentSize)
     */
    function updateProductInfo(slide, size = currentSize) {
      const slideProductId =
        slide.getAttribute(`data-${size}-id`) ||
        slide.getAttribute("data-slide-product-id");
      const baseProductUrl = slide
        .getAttribute("data-product-url")
        .split("?")[0];
      const slideProductTitle = slide.getAttribute("data-product-title");
      const slideProductPrice = parseInt(
        slide.getAttribute(`data-${size}-price`) ||
          slide.getAttribute("data-product-price")
      );

      const compareAtPrice = card.querySelector("[data-base-compare-price]");
      const sideShieldPrice =
        parseInt(slide.getAttribute("data-sideshield-price")) || 65;

      // Store original prices if not already stored
      if (!card.dataset.originalPrice) {
        card.dataset.originalPrice = slideProductPrice;
      }
      if (compareAtPrice && !card.dataset.originalComparePrice) {
        card.dataset.originalComparePrice = parseInt(
          compareAtPrice.textContent.replace(/[^0-9]/g, "")
        );
      }

      // Calculate prices
      let currentPrice = parseInt(card.dataset.originalPrice);
      let currentComparePrice = compareAtPrice
        ? parseInt(card.dataset.originalComparePrice)
        : 0;

      if (isSideShieldAdded) {
        currentPrice += sideShieldPrice;
        if (compareAtPrice) {
          currentComparePrice += sideShieldPrice;
        }
      }

      // Update prices
      if (productPrice) {
        productPrice.textContent = `$${currentPrice}`;
      }

      if (compareAtPrice) {
        compareAtPrice.textContent = `$${currentComparePrice}`;
      }

      let updatedProductUrl = `${baseProductUrl}?variant=${slideProductId}`;

      // Add side shield query param if side shield is added
      if (isSideShieldAdded) {
        updatedProductUrl += "&addons=sideshields";
      }

      card.setAttribute("data-default-product-id", slideProductId);
      if (productCardUrl) productCardUrl.href = updatedProductUrl;
      if (productImageUrl) productImageUrl.href = updatedProductUrl;
      if (productReviewUrl)
        productReviewUrl.href = `${updatedProductUrl}#pdp-review-section`;

      // Ensure collection->PDP links carry the currently selected frame-size filter
      const attachFrameSizeParam = (anchor) => {
        if (!anchor) return;

        const addParam = () => {
          try {
            const checked = document.querySelector(
              'input[data-filter-type="frame-size"]:checked'
            );
            if (!checked) return;
            const size = (
              checked.getAttribute("data-frame-size") || ""
            ).toLowerCase();
            if (!size) return;
            const url = new URL(anchor.href, window.location.origin);
            url.searchParams.set("frame_size", size);
            anchor.href = url.toString();
          } catch (e) {
            // ignore URL errors
          }
        };

        anchor.addEventListener("click", addParam, { capture: true });
        anchor.addEventListener("auxclick", (e) => {
          if (e.button === 1) addParam();
        });
      };

      attachFrameSizeParam(productCardUrl);
      attachFrameSizeParam(productImageUrl);
      attachFrameSizeParam(productReviewUrl);

      if (productVariantTitle) {
        // Get the display title which has the format "Frame Color, Lens Type"
        const displayTitle = slide.getAttribute("data-display-title");

        if (displayTitle) {
          // Split by comma to get frame color and lens type
          const [frameColor, lensType] = displayTitle
            .split(", ")
            .map((s) => s.trim());

          productVariantTitle.innerHTML = `
            <span>${frameColor}</span>
            <span>${lensType}</span>
          `;
        }
      }

      updateFeaturedImage(slide);

      // Check availability of the selected frame size
      const isAvailable =
        slide.getAttribute(`data-is-${size}-available`) === "true";

      // Update quickAddButton if it exists
      if (quickAddButton) {
        quickAddButton.setAttribute("data-product-id", slideProductId);
        // Only set side shield ID if side shield is available
        if (card.hasAttribute("data-sideshield-id")) {
          quickAddButton.setAttribute(
            "data-side-shield-id",
            card.getAttribute("data-sideshield-id")
          );
        }

        // Update button text and disabled state based on availability
        if (isAvailable) {
          quickAddButton.textContent = "Add to Cart";
          quickAddButton.disabled = false;
          quickAddButton.classList.remove("klaviyo-collection-bis-trigger");
          quickAddButton.style.cursor = "pointer";
          quickAddButton.style.opacity = 1;
        } else {
          quickAddButton.textContent = "Notify when in stock";
          quickAddButton.disabled = false;
          quickAddButton.classList.add("klaviyo-collection-bis-trigger");
          quickAddButton.setAttribute("data-variant", slideProductId);

          // Create product name with current frame size
          let productName = slideProductTitle;
          const sizeFormatted = size.charAt(0).toUpperCase() + size.slice(1);
          productName += ` / ${sizeFormatted}`;

          quickAddButton.setAttribute("data-product-name", productName);
          quickAddButton.setAttribute("data-product-id", slideProductId);
          quickAddButton.style.cursor = "pointer";
          quickAddButton.style.opacity = 1;
        }
      }
    }

    /**
     * Updates the featured image based on the selected slide and side shield status
     * @param {HTMLElement} slide - The selected slide element
     */
    function updateFeaturedImage(slide) {
      const currentSlideImageSrc =
        slide.querySelector("[data-thumb-image]")?.src;
      const sideShieldImageSrc = slide.getAttribute("data-side-shield-image");

      // Preload the images
      preloadImage(currentSlideImageSrc);
      if (sideShieldImageSrc) {
        preloadImage(sideShieldImageSrc);
      }

      if (isSideShieldAdded && sideShieldImageSrc) {
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          featuredImageElement.src = sideShieldImageSrc;
        });
      } else {
        requestAnimationFrame(() => {
          featuredImageElement.src = currentSlideImageSrc;
        });
      }
    }

    // Add event listeners to slides
    slides.forEach((slide) => {
      slide.addEventListener("click", (event) => {
        event.stopPropagation();
        slides.forEach((s) => s.classList.remove("is-active"));
        slide.classList.add("is-active");
        activeSlide = slide;
        alertShownForCurrentSlide = false; // Reset the alert flag
        updateProductInfo(slide, currentSize);

        // Check availability of the selected frame size
        const isAvailable =
          slide.getAttribute(`data-is-${currentSize}-available`) === "true";

        // Update quickAddButton if it exists
        if (quickAddButton) {
          if (isAvailable) {
            quickAddButton.textContent = "Add to Cart";
            quickAddButton.disabled = false;
            quickAddButton.classList.remove("klaviyo-collection-bis-trigger");
            quickAddButton.style.cursor = "pointer";
            quickAddButton.style.opacity = 1;
          } else {
            quickAddButton.textContent = "Notify when in stock";
            quickAddButton.disabled = false;
            quickAddButton.classList.add("klaviyo-collection-bis-trigger");
            quickAddButton.setAttribute(
              "data-variant",
              slide.getAttribute(`data-${currentSize}-id`) ||
                slide.getAttribute("data-slide-product-id")
            );
            // Create product name with current frame size
            let productName = slide.getAttribute("data-product-title");
            const sizeFormatted =
              currentSize.charAt(0).toUpperCase() + currentSize.slice(1);
            productName += ` / ${sizeFormatted}`;
            quickAddButton.setAttribute("data-product-name", productName);
            quickAddButton.setAttribute(
              "data-product-id",
              slide.getAttribute(`data-${currentSize}-id`) ||
                slide.getAttribute("data-slide-product-id")
            );
            quickAddButton.style.cursor = "pointer";
            quickAddButton.style.opacity = 1;
          }
        }
      });

      // Handle side shield toggle
      if (sideShieldToggle) {
        sideShieldToggle.addEventListener("change", (event) => {
          isSideShieldAdded = event.target.checked;
          const sideShieldImageSrc = activeSlide.getAttribute(
            "data-side-shield-image"
          );

          if (
            isSideShieldAdded &&
            !sideShieldImageSrc &&
            !alertShownForCurrentSlide
          ) {
            injectCustomMessage(
              "Unfortunately, the image of the side shield is currently unavailable.",
              card.querySelector(".ombraz-product-v2__price"),
              true
            );
            alertShownForCurrentSlide = true;
          } else if (!isSideShieldAdded) {
            injectCustomMessage(
              "",
              card.querySelector(".ombraz-product-v2__price"),
              false
            );
            alertShownForCurrentSlide = false;
          }

          if (isSideShieldAdded) {
            updateProductInfo(activeSlide);
          } else {
            updateProductInfo(activeSlide);
          }

          updateFeaturedImage(activeSlide);
        });
      }

      /**
       * Updates the product information when a new size is selected
       * @param {string} size - The selected size
       */
      function updateSizeSelection(size) {
        currentSize = size;
        updateProductInfo(activeSlide, size);

        // Check availability of the selected frame size
        const isAvailable =
          activeSlide.getAttribute(`data-is-${size}-available`) === "true";

        // Update quickAddButton if it exists
        if (quickAddButton) {
          if (isAvailable) {
            quickAddButton.textContent = "Add to Cart";
            quickAddButton.disabled = false;
            quickAddButton.classList.remove("klaviyo-collection-bis-trigger");
            quickAddButton.style.cursor = "pointer";
            quickAddButton.style.opacity = 1;
          } else {
            quickAddButton.textContent = "Notify when in stock";
            quickAddButton.disabled = false;
            quickAddButton.classList.add("klaviyo-collection-bis-trigger");
            quickAddButton.setAttribute(
              "data-variant",
              activeSlide.getAttribute(`data-${size}-id`) ||
                activeSlide.getAttribute("data-slide-product-id")
            );

            // Create product name with current frame size
            let productName = activeSlide.getAttribute("data-product-title");
            const sizeFormatted = size.charAt(0).toUpperCase() + size.slice(1);
            productName += ` / ${sizeFormatted}`;

            quickAddButton.setAttribute("data-product-name", productName);
            quickAddButton.setAttribute(
              "data-product-id",
              activeSlide.getAttribute(`data-${size}-id`) ||
                activeSlide.getAttribute("data-slide-product-id")
            );
            quickAddButton.style.cursor = "pointer";
            quickAddButton.style.opacity = 1;
          }
        }
      }

      // Add event listeners to frame size buttons
      Object.entries(sizeButtons).forEach(([size, button]) => {
        if (button) {
          button.addEventListener("change", () => updateSizeSelection(size));
        }
      });
    });

    // Handle Add to Cart button click
    if (quickAddButton) {
      quickAddButton.addEventListener("click", () => {
        // Check if this is a Klaviyo back-in-stock trigger
        if (
          quickAddButton.classList.contains("klaviyo-collection-bis-trigger")
        ) {
          // Let the Klaviyo handler take care of this
          return;
        }

        const productId = quickAddButton.getAttribute("data-product-id");
        const sideShieldId = quickAddButton.hasAttribute("data-side-shield-id")
          ? quickAddButton.getAttribute("data-side-shield-id")
          : null;
        const items = [
          {
            id: parseInt(productId),
            quantity: 1,
          },
        ];

        if (isSideShieldAdded && sideShieldId) {
          items.push({
            id: parseInt(sideShieldId),
            quantity: 1,
          });
        }

        addToCart(items, quickAddButton);
      });
    }

    // Initialize product info with the first slide
    updateProductInfo(activeSlide);
  });
}

/**
 * Handles simple product cards that don't require the full slider functionality
 * Only handles available products, not OOS products (which are handled by Klaviyo BIS)
 */
function handleSimpleProductCards() {
  const simpleCards = Array.from(
    document.querySelectorAll(".ombraz-product-v2__card")
  );

  if (!simpleCards.length) return;

  simpleCards.forEach((card) => {
    // Only select buttons that are NOT klaviyo-collection-bis-trigger buttons
    const quickAddButton = card.querySelector(
      ".ombraz-product-v2__add-to-cart button:not(.klaviyo-collection-bis-trigger)"
    );

    if (!quickAddButton) return;

    // Double-check that this is NOT a Klaviyo BIS button
    if (quickAddButton.classList.contains("klaviyo-collection-bis-trigger")) {
      console.log("Skipping Klaviyo BIS button in simple cards handler");
      return;
    }

    const productId = card.getAttribute("data-product-id");

    quickAddButton.addEventListener("click", function () {
      if (this.classList.contains("klaviyo-collection-bis-trigger")) {
        // Prevent SLIDE CART from opening
        window.SLIDECART_OPENED = false;
        console.log("PREVENTED SLIDE CART");
        return;
      }

      const items = [
        {
          id: parseInt(productId),
          quantity: 1,
        },
      ];

      addToCart(items, quickAddButton);
    });
  });
}

/**
 * Injects or removes a custom message near the target element
 * @param {string} message - The message to inject
 * @param {HTMLElement} targetElement - The element to inject the message near
 * @param {boolean} shouldInject - Whether to inject or remove the message
 */
function injectCustomMessage(message, targetElement, shouldInject) {
  const existingMessage = targetElement.parentNode.querySelector(
    ".custom-alert-message"
  );

  if (shouldInject) {
    // If the message does not exist, create and inject it
    if (!existingMessage) {
      const newDiv = document.createElement("div");
      newDiv.className = "custom-alert-message";
      newDiv.textContent = message;

      // Insert the new div before the target element
      if (targetElement) {
        targetElement.parentNode.insertBefore(newDiv, targetElement);
      }
    }
  } else {
    // Remove the existing message if checkbox is unchecked
    if (existingMessage) {
      existingMessage.remove();
    }
  }
}

/**
 * Capitalizes the first letter of a string
 * @param {string} str - The string to capitalize
 * @returns {string} The capitalized string
 */
function toCapitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Adds items to the cart and updates the UI accordingly
 * @param {Array} items - An array of items to add to the cart
 * @param {HTMLElement} quickAddButton - The Add to Cart button element
 */
function addToCart(items, quickAddButton) {
  if (quickAddButton) {
    quickAddButton.textContent = "Adding item...";
    quickAddButton.disabled = true;
    quickAddButton.style.cursor = "not-allowed";
    quickAddButton.style.opacity = 0.5;
  }

  const formData = {
    items: items,
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((_data) => {
      setTimeout(() => {
        if (quickAddButton) {
          quickAddButton.textContent = "Added!";
          quickAddButton.disabled = false;
          quickAddButton.style.cursor = "pointer";
          quickAddButton.style.opacity = 1;
          const cartCount = document.querySelector(".header-new__cart-count");
          if (cartCount) {
            cartCount.textContent = "";
            cartCount.textContent = _data?.items?.length;
          }

          setTimeout(() => {
            if (quickAddButton) {
              quickAddButton.textContent = "Add to Cart";
            }
          }, 2000);
          SLIDECART_UPDATE();
          SLIDECART_OPEN();
        }
      }, 1000);
    })
    .catch((_error) => {
      if (quickAddButton) {
        quickAddButton.textContent = "Adding item...";
        quickAddButton.disabled = false;
        quickAddButton.style.cursor = "pointer";
        quickAddButton.style.opacity = 1;

        setTimeout(() => {
          if (quickAddButton) {
            quickAddButton.textContent = "Add to Cart";
          }
        }, 3000);
      }
    });
}

/**
 * Handles accessory product cards (sideshield, riser, gear, etc.)
 * Only handles available products with 'accessory-quick-add-btn' class
 */
function handleAccessoryProductCards() {
  // Only select buttons that have EXACTLY the accessory-quick-add-btn class
  const accessoryButtons = Array.from(
    document.querySelectorAll("button.accessory-quick-add-btn")
  );

  if (!accessoryButtons.length) return;

  console.log(
    `Found ${accessoryButtons.length} available accessory buttons to handle`
  );

  accessoryButtons.forEach((button) => {
    // Double-check that this is NOT a Klaviyo BIS button
    if (button.classList.contains("klaviyo-collection-bis-trigger")) {
      console.log("Skipping Klaviyo BIS button in accessory handler");
      return;
    }

    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      console.log(
        "Available accessory button clicked:",
        button.getAttribute("data-accessory-type")
      );

      const variantId =
        button.getAttribute("data-variant-id") ||
        button.getAttribute("data-product-id");

      if (!variantId) {
        console.error("Error: Variant ID is missing for accessory product.");
        return;
      }

      const items = [
        {
          id: parseInt(variantId),
          quantity: 1,
        },
      ];

      addToCart(items, button);
    });
  });
}

// Initialize the functionality when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  v2CollectionPdpSlider();
  handleSimpleProductCards();
  handleAccessoryProductCards();
});
